module.exports = __webpack_public_path__ + "img/guide_1_2.23672f75.svg";